<template>
  <div
    v-if="isIncreasePercent"
    :class="isEqual ? '' : {
      'table-cell__incr': isIncrease,
      'table-cell__decr': isDecrease,
    }"
  >
    <i
      v-if="!isEqual"
      :class="{
        'el-icon-caret-top': isIncrease,
        'el-icon-caret-bottom': isDecrease,
      }"
    />
    {{ value }}%
  </div>
  <div v-else>{{ value }}</div>
</template>

<script>
import accounting from 'accounting';

export default {
  props: {
    dataSource: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      moneyKeys: ['cost_total', 'ecpm', 'acp'],
      thousandsKeys: [
        'cost_total',
        'ecpm',
        'acp',
        'request',
        'impression_total',
        'click_total',
        'served_account_num',
        'served_request',
      ],
      percentKeys: ['filled_rate', 'ctr'],
    };
  },

  computed: {
    isIncreasePercent() {
      return this.row.date === '涨幅百分比';
    },

    row() {
      return this.dataSource.row;
    },

    column() {
      return this.dataSource.column;
    },

    property() {
      return this.column.property;
    },

    value() {
      const v = this.row[this.property];

      if (this.isIncreasePercent) {
        return v;
      }

      if (this.thousandsKeys.includes(this.property)) {
        if (this.moneyKeys.includes(this.property)) {
          return accounting.formatMoney(v, '￥');
        }
        return accounting.formatNumber(v);
      } else if (this.percentKeys.includes(this.property)) {
        return `${v}%`;
      }

      return v;
    },

    isEqual() {
      return this.value === 0;
    },

    isIncrease() {
      return this.value > 0;
    },

    isDecrease() {
      return this.value < 0;
    },
  },
};
</script>


<style lang="less" scoped>
.table-cell {
  &__incr {
    color: @crm-rise-color;
  }

  &__decr {
    color: @crm-fall-color;
  }
}
</style>